// opervex-frontend/src/Opervex/HumanResources/index.js

import _Employees from "./Employees";
import _Teams from "./Teams";
import _Sectors from "./Sectors";
import _Roles from "./Roles";
import _Integrations from "./Integrations";

class HumanResources {
  #_api;

  constructor(api) {
    this.#_api = api;

    this.Employees = new _Employees(this.#_api);
    this.Teams = new _Teams(this.#_api);
    this.Sectors = new _Sectors(this.#_api);
    this.Roles = new _Roles(this.#_api);
    this.Integrations = new _Integrations(this.#_api);
  }
}

export default HumanResources;
